import React, { useEffect, useRef } from "react";
import { OnboardingPage } from "../common/layout";
import { Button } from "../../components/ui/button";
import { ArrowRightIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { TekkrIcon } from "../../components/shared/tekkr/tekkr-logo";

export function OnboardingWelcomePage() {
    const iconRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        setTimeout(() => {
            if (iconRef.current) {
                iconRef.current.classList.add("drop-shadow-glow-primary");
            }
        }, 500);
    }, []);
    return (
        <OnboardingPage boxed={false}>
            <div className={"flex flex-col items-center gap-6"}>
                <div ref={iconRef} className={"transition-all duration-1000"}>
                    <TekkrIcon className={"mb-6 h-24 w-24 duration-1000 animate-in slide-in-from-bottom-4"} />
                </div>
                <h2 className={"duration-500 animate-in slide-in-from-bottom-1.5"}>Welcome to Tekkr!</h2>
                <p
                    className={
                        "max-w-md text-center text-muted-foreground duration-500 animate-in slide-in-from-bottom-0.5"
                    }
                >
                    Tekkr helps you implement battle-tested playbooks from top leaders to unlock the full potential of
                    your tech teams.
                </p>
                <Link to={"/"} replace={true}>
                    <Button className={"group px-8 font-semibold duration-700 animate-in slide-in-from-bottom-1"}>
                        <div className={"transition-all duration-500 group-hover:translate-x-1"}>Continue</div>
                        <ArrowRightIcon
                            className={"w-5h ms-2 h-5 transition-all duration-500 group-hover:translate-x-1.5"}
                        />
                    </Button>
                </Link>
            </div>
        </OnboardingPage>
    );
}
